import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./login.css";
import Imagens from "../../components/IMAGESCOMPONENT/ImageComponent";


function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();

  function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setErrorMessage("");

    const emailLimpo = email.trim();
    const senhaLimpa = senha.trim();

    // LOGIN ADMIN LOCAL
    if (
      emailLimpo.toLowerCase() === "admin@eliandro.com" &&
      senhaLimpa === "Le2012#2"
    ) {
      const tokenAdmin = btoa(
        `34|${new Date().toISOString()}`
      );

      sessionStorage.setItem("tokenAdmin", tokenAdmin);

      setLoading(false);
      navigate("/");
      return;
    }

    fetch("https://app.eliandroalimentos.com.br/api/primeiro_acesso/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: emailLimpo,
        senha: senhaLimpa,
      }),
    })
      .then((res) => res.json().then((data) => ({ status: res.status, data })))
      .then(({ status, data }) => {
        if (status === 200) {
          localStorage.setItem("token", data.data.token);
          console.log("token", data)
          navigate("/");
        } else if (data.error) {
          setErrorMessage("Email ou senha estão incorretos. Tente novamente.");
        } else {
          setErrorMessage("Sistema indisponível. Tente novamente mais tarde.");
        }
      })
      .catch((err) => {
        console.error("Erro no login:", err);
        setErrorMessage("Sistema indisponível. Tente novamente mais tarde.");
      })
      .finally(() => setLoading(false));
  }

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <div className="login-brand">
          <img src={Imagens.Logo}
            onClick={() => navigate("/")}
            style={{ cursor: "pointer" }}
            alt="Eliandro Alimentos" />
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          {errorMessage && <div className="login-error">{errorMessage}</div>}

          {/* EMAIL */}
          <div className="login-input-group">
            <label>Email</label>
            <div className="login-input-wrapper">
              <input
                type="email"
                placeholder="seu@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          {/* SENHA */}
          <div className="login-input-group">
            <label>Senha</label>
            <div className="login-input-wrapper login-password-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="••••••••"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                required
              />
              <button
                type="button"
                className="login-toggle-password"
                onClick={() => setShowPassword(!showPassword)}
                aria-label="Mostrar ou ocultar senha"
              >
                {showPassword ? (
                  <svg viewBox="0 0 24 24">
                    <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12z" />
                    <circle cx="12" cy="12" r="3" />
                    <line x1="3" y1="3" x2="21" y2="21" />
                  </svg>
                ) : (
                  <svg viewBox="0 0 24 24">
                    <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                )}
              </button>
            </div>
          </div>

          {/* BOTÃO */}
          <button className="login-button" disabled={loading}>
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>


        {/* ESQUECEU A SENHA */}
        <div className="login-forgot-password">
          <button
            type="button"
            className="login-link-button"
            onClick={() => navigate("/novasenha")}
          >
            Esqueceu sua senha?
          </button>
        </div>

        {/* FOOTER */}
        <div className="login-footer">
          <div className="login-first-access">
            <span>Primeiro acesso?</span>
            <button
              type="button"
              className="login-link-button"
              onClick={() => navigate("/primeiroacesso")}
            >
              Clique aqui
            </button>
          </div>

          <div className="login-divider" />

          <div className="login-register">
            <span>Ainda não tem cadastro?</span>
            <button
              type="button"
              className="login-link-button"
              onClick={() => navigate("/cadastro")}
            >
              Cadastre-se
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
